import { useContext, useEffect, useState } from "react";
import { Footer } from "../../components/footer";
import { Header } from "../../components/header";
import { MotobombaContext } from "../../contexts/contexMotobomba";
import {
  DadosMotoBombaStyled,
  Dot,
  MotoBombaStyled,
} from "../../styles/motoBomba";
import imgMotobomba from "../../assets/icons/motobombaWhite.png";
import { IoNotificationsCircle } from "react-icons/io5";
import { ModalAlertasMotoBomba, ModalConfimacaoMotoBomba } from "./modals";
import { LuPower, LuPowerOff } from "react-icons/lu";
import { DadosMotoomba } from "./dadosMotobomba";
import { SquareLoading } from "../../components/loaders";

export const MotoBombaJm = () => {
  const {
    motobombaSalve,
    modalAlertaMotobomba,
    setModalAlertaMotobomba,
    alertasMotoBombas,
    modalConfimetionMotobomba,
    setModalConfimationMotobomba,
    funtionControleSave,
    setFuntionConoleSave,
    acleracaoList,
    setAceleracaoListe,
    listMotoBomba,
    loading,
  } = useContext(MotobombaContext);

  const [expandedMotoBomba, setExpandedMotoBomba] = useState([1]);

  const toggleItemExpansion = (itemId) => {
    setExpandedMotoBomba((prevExpandedItems) =>
      prevExpandedItems.includes(itemId)
        ? prevExpandedItems.filter((id) => id !== itemId)
        : [...prevExpandedItems, itemId]
    );
  };
  useEffect(() => {
    listMotoBomba();

    const intervalId = setInterval(() => {
      listMotoBomba();
    }, 15000); // 1000 milissegundos = 1 segundos

    // Limpa o intervalo quando o componente é desmontado
    return () => clearInterval(intervalId);
  }, []);

  const [mensagemModal, setMensagemModal] = useState("");

  useEffect(() => {
    const inicialAceleracao = {};
    motobombaSalve.forEach((bombController) => {
      inicialAceleracao[bombController.pivo] = bombController.aceleracao;
    });
    setAceleracaoListe(inicialAceleracao);
  }, [motobombaSalve]);

  const handleAceleracao = (motobombaId, newValue) => {
    let updatedValue;

    // Verificar se o novo valor é zero ou dentro do intervalo desejado
    if (newValue === 0 || (newValue >= 0 && newValue <= 100)) {
      updatedValue = newValue;
    } else if (newValue < 0) {
      updatedValue = 0;
    } else {
      updatedValue = 100;
    }

    const updatedAceleracao = {
      ...acleracaoList,
      [motobombaId]: updatedValue,
    };

    setAceleracaoListe(updatedAceleracao);
  };
  return (
    <MotoBombaStyled>
      <Header tanque={true} motobomba={true} />
      {modalAlertaMotobomba && (
        <ModalAlertasMotoBomba alertas={alertasMotoBombas} />
      )}
      {modalConfimetionMotobomba && (
        <ModalConfimacaoMotoBomba mensagem={mensagemModal} />
      )}
      {loading && <SquareLoading />}
      <section>
        <ul className="conteiner">
          {motobombaSalve.map((motoBomba) => {
            const isExpanded = expandedMotoBomba.includes(motoBomba.id);
            return (
              <li
                className={isExpanded ? "expanded motoBomba" : "motoBomba"}
                key={motoBomba.id}
              >
                <span className="alertas">
                  <IoNotificationsCircle
                    onClick={() =>
                      setModalAlertaMotobomba(!modalAlertaMotobomba)
                    }
                  />
                </span>
                <div
                  className="nomeMotoBomba"
                  onClick={() => toggleItemExpansion(motoBomba.id)}
                >
                  <img src={imgMotobomba} alt="" />
                  <h2>{motoBomba.nome}</h2>
                </div>
                <div className="controles">
                  <h3>Controle</h3>
                  <ul>
                    <li>
                      <div className="ControleAnimation">
                        <p>Acionamento</p>
                        <div>
                          <span>Manual</span>
                          <button
                            className="buttonSelect"
                            onClick={() => {
                              if (motoBomba.manual) {
                                setMensagemModal("Mudar para Autómatico");

                                setModalConfimationMotobomba(
                                  !modalConfimetionMotobomba
                                );
                                setFuntionConoleSave([
                                  "acionamento",
                                  motoBomba.manual,
                                  motoBomba.id,
                                ]);
                              } else {
                                setMensagemModal("Mudar para Manual");
                                setModalConfimationMotobomba(
                                  !modalConfimetionMotobomba
                                );
                                setFuntionConoleSave([
                                  "acionamento",
                                  motoBomba.manual,
                                  motoBomba.id,
                                ]);
                              }
                            }}
                          >
                            <Dot isLeft={motoBomba.manual} />
                          </button>
                          <span>Autómatico</span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="ControleAnimation">
                        <p>Painel</p>
                        <div
                          className={`${motoBomba.manual ? "desativado" : ""}`}
                        >
                          <span>Ligado</span>
                          <button
                            disabled={motoBomba.manual}
                            className="buttonSelect"
                            onClick={() => {
                              if (motoBomba.painel) {
                                setMensagemModal("Desligar o Painel");
                                setModalConfimationMotobomba(
                                  !modalConfimetionMotobomba
                                );
                                setFuntionConoleSave([
                                  "painel",
                                  motoBomba.painel,
                                  motoBomba.id,
                                ]);
                              } else {
                                setMensagemModal("Ligar o Painel");
                                setModalConfimationMotobomba(
                                  !modalConfimetionMotobomba
                                );
                                setFuntionConoleSave([
                                  "painel",
                                  motoBomba.painel,
                                  motoBomba.id,
                                ]);
                              }
                            }}
                          >
                            <Dot isLeft={motoBomba.painel} />
                          </button>
                          <span>Desligado</span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="ControleAnimation">
                        <p>Motor</p>
                        <div
                          className={` ${
                            !motoBomba.manual && motoBomba.painel
                              ? ""
                              : "desativado"
                          }`}
                        >
                          <span>Ligado</span>
                          <button
                            disabled={
                              motoBomba.manual
                                ? true
                                : motoBomba.painel
                                ? false
                                : true
                            }
                            className="buttonSelect"
                            onClick={() => {
                              if (motoBomba.ignicao) {
                                setMensagemModal("Desligar o Motor");
                                setModalConfimationMotobomba(
                                  !modalConfimetionMotobomba
                                );
                                setFuntionConoleSave([
                                  "power",
                                  motoBomba.ignicao,
                                  motoBomba.id,
                                ]);
                              } else {
                                setMensagemModal("Ligar o Motor");
                                setModalConfimationMotobomba(
                                  !modalConfimetionMotobomba
                                );
                                setFuntionConoleSave([
                                  "power",
                                  motoBomba.ignicao,
                                  motoBomba.id,
                                ]);
                              }
                            }}
                          >
                            <Dot isLeft={motoBomba.ignicao} />
                          </button>
                          <span>Desligado</span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="ControleAnimation">
                        <p>Aceleraçâo</p>
                        <div
                          className={`${
                            !motoBomba.manual && motoBomba.painel
                              ? ""
                              : "desativado"
                          }`}
                        >
                          <input
                            disabled={
                              motoBomba.manual
                                ? true
                                : motoBomba.painel
                                ? false
                                : true
                            }
                            type="number"
                            defaultValue={motoBomba.aceleracao}
                            value={acleracaoList[motoBomba.id]}
                            onChange={(e) =>
                              handleAceleracao(motoBomba.id, e.target.value)
                            }
                          />
                          <button
                            className="bunttonConfirmation"
                            onClick={() => {
                              setMensagemModal("Mudar o valor");
                              setModalConfimationMotobomba(
                                !modalConfimetionMotobomba
                              );
                              setFuntionConoleSave([
                                "aceleracao",
                                acleracaoList[motoBomba.id],
                                motoBomba.id,
                              ]);
                            }}
                          >
                            Acelerar
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <DadosMotoomba Motor={motoBomba} />
              </li>
            );
          })}
        </ul>
      </section>
      <Footer />
    </MotoBombaStyled>
  );
};
